import React from 'react';
import {Typography} from '../../../../core/components';
import AdminPage from '../../../../core/components/admin-page/AdminPage';
import {colorTheme} from '../../../../core/configs';
import { useAuth } from '../../../hooks/useAuth';

const AdminLandingPage = () => {
  const {authData} = useAuth();

  const getWelcomeMessage = (): string => { 
    let message = "Welcome to kazam admin";

    if (!!authData?.user?.userDepartment) {
      message = message + ` <b>${authData.user?.firstName ?? ""} ${authData.user?.lastName ?? ""}</b>`;
    }
    return message + "!";
  }

  return (
    <AdminPage>
      <div>
        <Typography
          label={getWelcomeMessage()}
          variant="f3"
          weight="semibold"
          color={colorTheme.dark}
        />
      </div>
    </AdminPage>
  );
};

export default AdminLandingPage;
